
























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { cloneDeep } from 'lodash';
import { currencyToNumber, numberMask } from '@/data/utils/helper';
import { Offer } from '@/data/models/offer.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class FattorinoOffer extends Vue {
	@Prop() model!: Offer;

	newModel: Offer;

	numberMask: any = numberMask()
	currencies: any = {};

	constructor() {
		super();
		this.newModel = new Offer();
	}

	beforeMount() {
		this.newModel = cloneDeep(this.model);
	}

	onCurrencyChange(event: any, field: string) {
		this.currencies[field] = currencyToNumber(event.target._vCleave.getFormattedValue());
	}

	submit() {
		Object.keys(this.currencies).forEach(k => {
			this.$set(this.newModel, k, this.currencies[k]);
		});
		this.$emit('submit', this.newModel);
	}

	close() {
		(this.$parent as any).close();
	}

}
